import { getArrayApiClient } from 'adapter/out/client/apiClient';
import User from 'domain/entity/user';

const readUsersApiClient = getArrayApiClient(() => `users/filtered`, User);

export default readUsersApiClient;
